import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Loader } from '../../shared/loader/loader';
import { getStateOptions } from '../../shared/data/state-visit-config';
import { SheetLoggerService } from '../../shared/services/sheet-logger.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-in-person-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, Loader],
  template: `
    <div class="inperson-modal-backdrop" *ngIf="isVisible" (click)="onBackdrop($event)">
      <div class="inperson-modal" (click)="$event.stopPropagation()">
        <app-loader *ngIf="isSubmitting" [fullscreen]="true" [message]="'Saving'"></app-loader>
        <div class="modal-header">
          <span class="modal-title">In-Person Appointment</span>
          <button type="button" class="modal-close" (click)="close()">✕</button>
        </div>
        <div class="modal-body">
          <div class="modal-grid">
            <div class="grid-col">
              <label class="modal-label">Legal First Name<span class="required-asterisk">*</span></label>
              <input type="text" class="modal-input" maxlength="20" [(ngModel)]="form.firstName" (input)="errors.firstName=''"/>
              <div class="modal-error" *ngIf="errors.firstName">{{ errors.firstName }}</div>
            </div>
            <div class="grid-col">
              <label class="modal-label">Legal Last Name<span class="required-asterisk">*</span></label>
              <input type="text" class="modal-input" maxlength="20" [(ngModel)]="form.lastName" (input)="errors.lastName=''"/>
              <div class="modal-error" *ngIf="errors.lastName">{{ errors.lastName }}</div>
            </div>
            <div class="grid-col">
              <label class="modal-label">Phone Number<span class="required-asterisk">*</span></label>
              <input type="text" class="modal-input" [(ngModel)]="form.phone" (input)="formatPhone($event); errors.phone=''" maxlength="12"/>
              <div class="modal-error" *ngIf="errors.phone">{{ errors.phone }}</div>
            </div>
            <div class="grid-col">
              <label class="modal-label">Email Address<span class="required-asterisk">*</span></label>
              <input type="email" class="modal-input" maxlength="40" [(ngModel)]="form.email" (input)="errors.email=''"/>
              <div class="modal-error" *ngIf="errors.email">{{ errors.email }}</div>
            </div>
            <div class="grid-col span-2 full-width">
              <label class="modal-label">What is your state of residence? <span class="required-asterisk">*</span></label>
              <div class="modal-select">
                <select class="modal-input" [(ngModel)]="form.state" (change)="errors.state=''">
                  <option value="">Select your state</option>
                  <option *ngFor="let st of stateOptions" [value]="st.value">{{ st.label }}</option>
                </select>
              </div>
              <div class="modal-error" *ngIf="errors.state">{{ errors.state }}</div>
            </div>
            <div class="grid-col span-2">
              <div class="info-note">
                <span class="info-icon">i</span>
                <div class="info-text">
                  <strong>Note:</strong> In-person appointments are currently available only at our North Carolina location. If you are located in another state, please select a Telehealth Appointment instead.
                </div>
              </div>
            </div>
          </div>
          <div class="consent-row">
            <input type="checkbox" class="consent-checkbox" [(ngModel)]="form.consent" (change)="errors.consent=''"/>
            <span class="consent-text">
              By checking this box, I consent to receive text messages related to information, appointments and practice updates from Animo Sano Psychiatry, PLLC. You can reply "STOP" at any time to opt-out. Message and data rates may apply. Message frequency may vary; text HELP to <a href="tel:+19193917202">(919) 391-7202</a> for assistance. For more information, please refer to our <a href="https://animosanopsychiatry.com/privacy-policy/" target="_blank">Privacy policy</a> and <a href="https://animosanopsychiatry.com/privacy-policy/#sms-tc" target="_blank">SMS Terms and Conditions</a> on our website.
            </span>
          </div>
          <div class="modal-error" *ngIf="errors.consent">{{ errors.consent }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="modal-submit" (click)="onSubmit()">Submit</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .inperson-modal-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
    .inperson-modal { width: 650px; max-width: 95vw; background: #ffffff; border-radius: 8px; box-shadow: 0 10px 25px rgba(0,0,0,0.2); overflow: hidden; font-family: Arial, sans-serif; max-height: 90vh; overflow-y: auto; }
    .modal-header { background: #2367B9; color: #ffffff; padding: 14px 18px; display: flex; align-items: center; justify-content: space-between; }
    .modal-title { font-family: arial; font-weight: 500; font-size: 18px; line-height: 100%; letter-spacing: 0; vertical-align: middle; }
    .modal-close { background: transparent; border: 0; color: #ffffff; font-size: 16px; cursor: pointer; }
    .modal-body { padding: 26px 18px 0 18px; }
    .modal-footer { padding: 14px 18px 18px 18px; display: flex; justify-content: flex-end; }
    .modal-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
    .grid-col { display: flex; flex-direction: column; gap: 8px; }
    .grid-col.span-2 { grid-column: span 2; }
    .grid-col.full-width .modal-input { width: 100%; }
    .modal-label { font-family: arial; font-weight: 500; font-size: 16px; line-height: 100%; letter-spacing: 0; vertical-align: middle; color: #000000; margin-bottom: 6px; }
    .required-asterisk { color: #e31b0c; margin-left: 2px; }
    .modal-input { height: 36px; border: 1px solid #d0d5dd; border-radius: 6px; padding: 6px 10px; font-size: 14px; }
    .modal-input:focus { outline: none; border-color: #d0d5dd; box-shadow: none; }
    .modal-error { color: #e31b0c; font-size: 12px; margin-top: 4px; }
    .modal-select { position: relative; }
    .modal-select .modal-input { padding-right: 44px; }
    .consent-row { display: flex; gap: 8px; align-items: flex-start; margin-top: 16px; }
    .consent-checkbox { width: 20px; height: 20px; accent-color: rgb(35, 103, 185); }
    .consent-text { font-family: arial; font-weight: 400; font-size: 16px; line-height: 150%; letter-spacing: 0; color: #555; text-decoration: none; text-decoration-style: solid; text-decoration-skip-ink: auto; }
    .consent-text a { color: #1E56A0; text-decoration: underline; }
    .info-note { display: flex; gap: 8px; align-items: flex-start; background: rgb(217, 237, 247); padding: 10px 12px; border-radius: 6px; color: #235894; border: 1px solid #235894; }
    .info-icon { display: inline-flex; align-items: center; justify-content: center; width: 15px; height: 15px; border-radius: 50%; border: 2px solid #235894; color: #235894; font-weight: 700; font-size: 12px; flex-shrink: 0; margin-top: 4px; }
    .info-text { font-family: arial; font-weight: 400; font-size: 16px; line-height: 150%; letter-spacing: 0; color: #235894; }
    .modal-submit { background: #57D6FA; color: #235894; border: 0; border-radius: 32px; padding: 10px 50px; display: inline-flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer; font-family: arial; font-weight: 600; font-size: 16px; line-height: 26px; letter-spacing: 0; }
    @media (max-width: 768px) { .inperson-modal { width: 520px; max-height: 92vh; overflow-y: auto; } .modal-header { padding: 12px 16px; } .modal-title { font-size: 16px; } .modal-body { padding: 14px 16px 0 16px; } .modal-footer { padding: 12px 16px 16px 16px; } .modal-label { font-size: 14px; } .modal-input { height: 34px; font-size: 14px; } .consent-text { font-size: 16px; line-height: 140%; } .modal-submit { padding: 12px 36px; font-size: 15px; } }
    @media (max-width: 480px) { .inperson-modal-backdrop { align-items: flex-start; padding: 12px; overflow-y: auto; } .inperson-modal { width: 100vw; max-width: 100vw; border-radius: 0; max-height: 95vh; overflow-y: auto; } .modal-header { padding: 10px 12px; } .modal-title { font-size: 15px; } .modal-body { padding: 12px 12px 0 12px; } .modal-footer { padding: 10px 12px 12px 12px; } .modal-grid { grid-template-columns: 1fr; gap: 12px; } .grid-col.span-2 { grid-column: span 1; } .modal-label { font-size: 13px; } .modal-input { height: 32px; font-size: 13px; } .consent-row { gap: 6px; } .consent-text { font-size: 14px; line-height: 140%; } .modal-submit { width: 100%; padding: 12px; font-size: 15px; } }
  `]
})
export class InPersonModal {
  @Input() isVisible: boolean = false;
  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<void>();

  isSubmitting: boolean = false;
  form = { firstName: '', lastName: '', phone: '', email: '', state: '', consent: false };
  errors = { firstName: '', lastName: '', phone: '', email: '', state: '', consent: '' };
  stateOptions = getStateOptions().filter(s => s.value === 'NC');

  constructor(private sheetLogger: SheetLoggerService, private router: Router) {}

  onBackdrop(_e: Event) { this.close(); }
  close() { this.reset(); this.closed.emit(); }

  formatPhone(event: Event) {
    const input = event.target as HTMLInputElement;
    const digits = (input.value || '').replace(/\D/g, '').slice(0, 10);
    const formatted = digits.length <= 3 ? digits : (digits.length <= 6 ? `${digits.slice(0,3)}-${digits.slice(3)}` : `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`);
    input.value = formatted;
    this.form.phone = formatted;
  }

  private validate(): boolean {
    let ok = true;
    this.errors = { firstName: '', lastName: '', phone: '', email: '', state: '', consent: '' };
    const nameMax = 20; const emailMax = 40;
    const email = (this.form.email || '').trim();
    const first = (this.form.firstName || '').trim();
    const last = (this.form.lastName || '').trim();
    if (!first) { this.errors.firstName = 'Please enter your legal first name'; ok = false; } else if (first.length > nameMax) { this.errors.firstName = `Maximum ${nameMax} characters allowed`; ok = false; }
    if (!last) { this.errors.lastName = 'Please enter your legal last name'; ok = false; } else if (last.length > nameMax) { this.errors.lastName = `Maximum ${nameMax} characters allowed`; ok = false; }
    if (!email) { this.errors.email = 'Please enter your email address'; ok = false; } else if (email.length > emailMax) { this.errors.email = `Maximum ${emailMax} characters allowed`; ok = false; } else if (!/^\S+@\S+\.\S+$/.test(email)) { this.errors.email = 'Please enter a valid email address'; ok = false; }
    const phone = (this.form.phone || '').trim();
    if (!phone) { this.errors.phone = 'Please enter your phone number'; ok = false; } else if (!/^\d{3}-\d{3}-\d{4}$/.test(phone)) { this.errors.phone = 'Please enter a valid phone number'; ok = false; }
    if (!this.form.state) { this.errors.state = 'Please select your state of residence'; ok = false; }
    if (!this.form.consent) { this.errors.consent = 'Please consent to receive text messages to continue'; ok = false; }
    return ok;
  }

  private trackInPersonSubmitButtonClick() {
    try {
      const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
      dataLayer.push({
        event: 'ols_in_person_submit_button_click',
        click_source: 'in_person_modal'
      });
    } catch {}
  }

  private trackInPersonFormSubmission() {
    try {
      const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
      dataLayer.push({
        event: 'ols_in_person_form_submission',
        click_source: 'in_person_modal'
      });
    } catch {}
  }

  onSubmit() {
    this.trackInPersonSubmitButtonClick();
    if (!this.validate()) return;
    this.isSubmitting = true;
    try {
      this.sheetLogger.logInPersonLead({
        firstName: (this.form.firstName || '').trim(),
        lastName: (this.form.lastName || '').trim(),
        phone: (this.form.phone || '').trim(),
        email: (this.form.email || '').trim(),
        state: (this.form.state || '').toString()
      }).subscribe({
        next: () => { this.trackInPersonFormSubmission(); this.isSubmitting = false; this.submitted.emit(); this.close(); try { this.router.navigate(['/inperson/success']); } catch {} },
        error: () => { this.isSubmitting = false; }
      });
    } catch { this.isSubmitting = false; }
  }

  private reset() {
    this.form = { firstName: '', lastName: '', phone: '', email: '', state: '', consent: false };
    this.errors = { firstName: '', lastName: '', phone: '', email: '', state: '', consent: '' };
  }
}


